/**
 * @desc 校验多渠道订单是否存在
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.CheckFulfillmentOrderDto, options?: any) {
  return updateResponse(
    http(URL + `/systemOrder/checkFulfillmentOrder`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
